import React, { useEffect, useRef, useState } from "react"
import { Row, Col, Modal, Button } from 'react-bootstrap';

const DataModal = (props) => {
  const { reasonShow, setReasonShow, data, title } = props;

  const handleCloseModal = () => {
    setReasonShow(false)
  }

  useEffect(() => {

  }, [reasonShow])

  return (
    <>
      <div>
        <Modal size="md" show={reasonShow} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <div className="mt-2">
                  <p>{data}</p>
                </div>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default DataModal